import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaClipboardList } from 'react-icons/fa';
import { BarChart, Bar, XAxis, YAxis, Tooltip, Cell, ResponsiveContainer } from 'recharts';
import { CHART_STATUS_COLORS } from '../../styles/chartColors';

const STATUS_META = {
  not_graded: { label: 'Not Graded', color: CHART_STATUS_COLORS.negative },
  partial_graded: { label: 'Partially Graded', color: CHART_STATUS_COLORS.warning },
  full_graded: { label: 'Fully Graded', color: CHART_STATUS_COLORS.positive },
};

const getCount = (value) => (typeof value === 'object' && value !== null ? value.count : value);
const getExams = (value) => (typeof value === 'object' && value !== null ? value.exams : null);

const ExamMarkingPipelineCard = ({ pipeline, link }) => {
  const [activeTab, setActiveTab] = useState('not_graded');

  if (!pipeline) return null;

  const data = Object.keys(STATUS_META).map((key) => ({
    key,
    name: STATUS_META[key].label,
    value: getCount(pipeline[key]),
  }));

  const hasExamLists = Object.keys(STATUS_META).some((key) => Array.isArray(getExams(pipeline[key])));
  const activeExams = getExams(pipeline[activeTab]) || [];

  return (
    <div className="col-xl-6 col-lg-6 col-md-12 mb-4">
      <div className="card dash-card h-100">
        <div className="dash-card-header">
          <span className="dash-card-header-title">
            <FaClipboardList />
            <span>Exam Marking Pipeline</span>
          </span>
          {link && <Link to={link} className="dash-view-link">Mark Now</Link>}
        </div>
        <div className="dash-card-body">
          <ResponsiveContainer width="100%" height={220}>
            <BarChart data={data} layout="vertical" margin={{ left: 20 }}>
              <XAxis type="number" allowDecimals={false} />
              <YAxis type="category" dataKey="name" width={110} />
              <Tooltip />
              <Bar dataKey="value" radius={[0, 8, 8, 0]} barSize={28}>
                {data.map((item) => (
                  <Cell key={item.key} fill={STATUS_META[item.key].color} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>

          {hasExamLists && (
            <div className="mt-2">
              <div className="dash-tab-group">
                {Object.keys(STATUS_META).map((key) => (
                  <button
                    key={key}
                    type="button"
                    className={`dash-tab ${activeTab === key ? 'dash-tab-active' : ''}`}
                    style={activeTab === key ? { borderColor: STATUS_META[key].color, color: STATUS_META[key].color } : undefined}
                    onClick={() => setActiveTab(key)}
                  >
                    {STATUS_META[key].label} ({getCount(pipeline[key]) || 0})
                  </button>
                ))}
              </div>

              {activeExams.length > 0 ? (
                <div className="dash-scroll-box">
                  {activeExams.map((exam) => (
                    <div key={exam.id} className="dash-exam-row">
                      <div className="dash-exam-row-title">{exam.subject_name} — {exam.program_name}</div>
                      <div className="dash-exam-row-meta">
                        Term {exam.term} • Exam #{exam.name} • {exam.start} to {exam.end}
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="small text-muted mt-2">No exams in this category.</div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ExamMarkingPipelineCard;
